export function handleMissingDataMessage(
  toastService: any,
  message: string | null,
) {
  if (message) {
    toastService.warn(message);
  }
}
